<div class="MainDiv">
	<!--Left Col, Filters-->
	<div class="FilterDiv">
		<label>Facility:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstFacility"
			[(ngModel)]="Facility"
			optionLabel="FacilityName"
			[filter]="true"
			filterBy="FacilityName"
			[showClear]="false"
			placeholder="Select a Facility"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Facility">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Facility.FacilityName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-FacilityItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ FacilityItem.FacilityName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Visitor Status:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstVisitorStatus"
			[(ngModel)]="VisitorStatus"
			optionLabel="VisitorStatusDesc"
			[filter]="true"
			filterBy="VisitorStatusDesc"
			[showClear]="false"
			placeholder="Select a Status Type"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="VisitorStatus">
					<div class="form-control NoBorder" style="text-align: left" [style.color]="VisitorStatus.AllowAdmittance == 1 ? 'Black' : 'Red'">
						{{ VisitorStatus.VisitorStatusDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-VisitorStatusItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left" [style.color]="VisitorStatusItem.AllowAdmittance == 1 ? 'Black' : 'Red'">
						{{ VisitorStatusItem.VisitorStatusDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Visitor Type:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstVisitorType"
			[(ngModel)]="VisitorType"
			optionLabel="VisitorTypeDesc"
			[filter]="true"
			filterBy="VisitorTypeDesc"
			[showClear]="false"
			placeholder="Select a Visitor Type"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="VisitorType">
					<div class="form-control NoBorder" style="text-align: left">
						{{ VisitorType.VisitorTypeDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-VisitorTypeItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ VisitorTypeItem.VisitorTypeDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Visit Reason:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstVisitorReason"
			[(ngModel)]="VisitorReason"
			optionLabel="VisitorReasonDesc"
			[filter]="true"
			filterBy="VisitorReasonDesc"
			[showClear]="false"
			placeholder="Select a Visit Reason"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="VisitorReason">
					<div class="form-control NoBorder" style="text-align: left">
						{{ VisitorReason.VisitorReasonDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-VisitorReasonItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ VisitorReasonItem.VisitorReasonDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>In Facility:</label>
		<p-dropdown
			[disabled]="IsLoading() == true"
			[options]="lstInFacility"
			[(ngModel)]="InFacility"
			optionLabel="Desc"
			[filter]="true"
			filterBy="Desc"
			[showClear]="false"
			placeholder="Select a Facility Option"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="InFacility">
					<div class="form-control NoBorder" style="text-align: left">
						{{ InFacility.Desc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-InFacilityItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ InFacilityItem.Desc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Date Range:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DateRangeOption" [(ngModel)]="DateRangeOption">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDateRangeOption" [ngValue]="o">
				{{ o.Desc }}
			</option>
		</select>

		<label *ngIf="DateRangeOption?.ID == -3">Start Date:</label>
		<p-calendar
			*ngIf="DateRangeOption?.ID == -3"
			[disabled]="IsLoading() == true"
			[(ngModel)]="StartDate"
			showIcon="true"
			showButtonBar="true"
		></p-calendar>

		<label *ngIf="DateRangeOption?.ID == -3">End Date:</label>
		<p-calendar *ngIf="DateRangeOption?.ID == -3" [disabled]="IsLoading() == true" [(ngModel)]="EndDate" showIcon="true" showButtonBar="true"></p-calendar>

		<label>Filter:</label>
		<input type="text" class="form-control" [(ngModel)]="FilterText" [disabled]="IsLoading() == true" />

		<button class="btn btn-primary CenterButton" (click)="onSearch()" [disabled]="IsLoading() == true">Search</button>
	</div>

	<!--Middle Col, Table-->
	<div class="TableDiv">
		<p-table
			#mydt
			[value]="lstVisitor"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedVisitor"
			dataKey="PersonID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--INSERT CUSTOM FILTERS HERE-->

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LicenseNbr-->
					<!-- <th>
                        <p-columnFilter type="text" field="LicenseNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
                    </th> -->

					<!--WaitingForVerifiedDesc-->
					<th>
						<p-columnFilter field="WaitingForVerifiedDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterWaitingForVerifiedDesc
									[ngModel]="value"
									[options]="lstFilterWaitingForVerifiedDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--ConfirmedOffenderDesc-->
					<th>
						<p-columnFilter field="ConfirmedOffenderDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterConfirmedOffenderDesc
									[ngModel]="value"
									[options]="lstFilterConfirmedOffenderDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--VisitorTypeDesc-->
					<th>
						<p-columnFilter field="VisitorTypeDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterVisitorTypeDesc
									[ngModel]="value"
									[options]="lstFilterVisitorTypeDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--VisitorStatusDesc-->
					<th>
						<p-columnFilter field="VisitorStatusDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterVisitorStatusDesc
									[ngModel]="value"
									[options]="lstFilterVisitorStatusDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--InFacilityDesc-->
					<th>
						<p-columnFilter field="InFacilityDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterInFacilityDesc
									[ngModel]="value"
									[options]="lstFilterInFacilityDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--LastPassDTDesc-->
					<th>
						<!-- <p-columnFilter type="text" field="LastPassDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->

						<p-columnFilter field="HasPassDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterHasPassDesc
									[ngModel]="value"
									[options]="lstFilterHasPassDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
					<!-- <th pSortableColumn="LicenseNbr">License<p-sortIcon field="LicenseNbr"></p-sortIcon></th> -->
					<th pSortableColumn="WaitingForVerified">Waiting For Verification<p-sortIcon field="WaitingForVerified"></p-sortIcon></th>
					<th pSortableColumn="ConfirmedOffender">Confirmed Offender<p-sortIcon field="ConfirmedOffender"></p-sortIcon></th>
					<th pSortableColumn="VisitorTypeDesc">Type<p-sortIcon field="VisitorTypeDesc"></p-sortIcon></th>
					<th pSortableColumn="VisitorStatusDesc">Status<p-sortIcon field="VisitorStatusDesc"></p-sortIcon></th>
					<th pSortableColumn="InFacilityDesc">In Facility<p-sortIcon field="InFacilityDesc"></p-sortIcon></th>
					<th pSortableColumn="LastPassDT">Last Pass Date<p-sortIcon field="LastPassDT"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Visitor>
				<tr [pSelectableRow]="Visitor">
					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Visitor.FirstName }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Visitor.LastName }}
					</td>

					<!-- <td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word;">
                        {{Visitor.LicenseNbr}}
                    </td> -->

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="Visitor.WaitingForVerified == false ? 'Black' : 'Red'"
					>
						{{ Visitor.WaitingForVerifiedDesc }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="Visitor.ConfirmedOffender == false ? 'Black' : 'Red'"
					>
						{{ Visitor.ConfirmedOffenderDesc }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Visitor.VisitorTypeDesc }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="Visitor.AllowAdmittance == 1 ? 'Black' : 'Red'"
					>
						{{ Visitor.VisitorStatusDesc }}
					</td>

					<td
						style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
						[style.color]="Visitor.InFacility == 1 ? 'limegreen' : 'Black'"
					>
						{{ Visitor.InFacilityDesc }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Visitor.LastPassDTDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Right Col, Preview-->
	<div class="ExtendedInfoDiv">
		<!--Image-->
		<div style="text-align: center">
			<img class="VisitorImage" [src]="VisitorImage" />
		</div>

		<!--Text-->
		<div class="ExtendedInfoGrid">
			<label>Notes:</label>
			<p>{{ VisitorNotes }}</p>

			<label>Last Pass Date:</label>
			<p>{{ VisitorLastPassDate }}</p>

			<label>Last Facility:</label>
			<p>{{ VisitorLastFacility }}</p>

			<label>Last Location:</label>
			<p>{{ VisitorLastFacilityLocation }}</p>
		</div>
	</div>
</div>
